import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import './Header.scss';
import logo from '../../utils/images/hcao-logo.png';
import menuIcon from '../../utils/images/menu-icon.png';
import { useMsal } from '@azure/msal-react';
import { useAuth } from '../../hooks/useAuth';

export default function Header({ menuToggleEnabled, title, toggleMenu }) {

  const HeaderTitle = () => {
    const { accounts } = useMsal();
    const { roleDisplayName } = useAuth()

    const username = accounts[0]?.name || "Guest";
  
    return (
      <div className="header-title-container">
        <p className="header-title-primary">Office of the Harris County Attorney</p>
        <p className="header-title-secondary">{`${username} (${roleDisplayName})`}</p>
      </div>
    );
  };

  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon={menuIcon} stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <p className='header-application-name'>Integrator App</p>
        </Item>
        {/* <Item
          location={'before'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item> */}
        <Item
          location={'after'}
          render={HeaderTitle}
        />
        <Item
          location={'after'}
        >
          <img alt="HCAO Logo" className="header-logo" src={logo} />
        </Item>
        {/* <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template> */}
      </Toolbar>
    </header>
)}
